// src/utils/autoLogout.js
// Utilitaire pour déconnexion automatique sur token invalide

import store from '../redux';
import Actions from '../redux/actions';

export function autoLogout() {
  // Supprime le token du localStorage
  localStorage.removeItem('jwt_access_token');
  // Réinitialise l'utilisateur dans le store
  store.dispatch(Actions.logout());
  // Redirige vers la page de login
  window.location.pathname = '/login';
}
